import React from 'react';
import './NewsletterInvite.css';

const NewsletterInvite = ({ newsletterChoice, handleNewsletterChoice }) => {
    if (newsletterChoice !== null) return null; // Hide if answered

    return (
        <div className="newsletter-card">
            <div className="newsletter-content">
                <h3 className="newsletter-title">
                    💬 ¿Te gustaría recibir ofertas personalizadas?
                </h3>
                <p className="newsletter-text">
                    Sobre los temas que tú elijas, sin spam y solo las mejores ofertas.
                </p>

                <div className="newsletter-actions">
                    <button
                        onClick={() => handleNewsletterChoice(true)}
                        className={`newsletter-btn yes ${newsletterChoice === true ? 'active' : ''}`}
                    >
                        🙋 Sí, me interesa {newsletterChoice === true && "✓"}
                    </button>
                    <button
                        onClick={() => handleNewsletterChoice(false)}
                        className={`newsletter-btn no ${newsletterChoice === false ? 'active' : ''}`}
                    >
                        🙅 No, gracias {newsletterChoice === false && "✓"}
                    </button>
                </div>

                {newsletterChoice === true && (
                    <div className="newsletter-confirmation">
                        <p>📧 Te avisaremos cuando esté lista la función</p>
                    </div>
                )}

                <p className="newsletter-disclaimer">
                    Solo alertas de precios + ofertas opcionales. Sin mailing de terceros.
                </p>
            </div>
        </div>
    );
};

export default NewsletterInvite;
